import locales from '@/constants/locales'

export const OPTIONAL_LOCALE_REGEX_PATTERN = `(/(${locales.all.join('|')}))?`
